export const ForceLogout = () => {
  localStorage.clear();
  window.location.href = '/login'
};
